/* unplugin-vue-components disabled */import { render } from "./Mobile.vue?vue&type=template&id=ae023f04"
const script = {}

import "./Mobile.vue?vue&type=style&index=0&id=ae023f04&lang=scss"

import exportComponent from "../../../../common/temp/node_modules/.pnpm/vue-loader@17.2.2_3tnefydtqxjg44ddub7xm4i2wi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__